import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import EmbedComponentEditable from './EmbedEditable';
import EmbedComponentReadOnly from './EmbedReadOnly';

const EmbedNodeView: React.FC = () => {
  const { node, view } = useReactNodeView();

  if (!view?.editable) {
    return <EmbedComponentReadOnly {...node?.attrs} />;
  }

  return <EmbedComponentEditable {...node?.attrs} />;
};

export default EmbedNodeView;
